import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft, Search } from 'lucide-react';
import SEO from '../components/SEO';

export default function NotFound() {
  return (
    <>
      <SEO 
        title="Page Not Found"
        description="The page you're looking for doesn't exist. Return to the TacticalSolutions.ai homepage or explore our AI automation solutions."
        noindex={true}
      />
      
      <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 pt-32 pb-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-7xl font-bold text-white mb-6">404</h1>
          <h2 className="text-3xl font-semibold text-gradient mb-6">Page Not Found</h2>
          <p className="text-xl text-gray-300 mb-12">
            The page you're looking for doesn't exist or has been moved.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            <Link
              to="/"
              className="glass-card p-6 rounded-xl backdrop-blur-md hover:scale-105 transition-all duration-300"
            >
              <Home className="h-8 w-8 text-teal-400 mx-auto mb-4" />
              <span className="text-white font-medium">Return Home</span>
            </Link>

            <Link
              to="/contact"
              className="glass-card p-6 rounded-xl backdrop-blur-md hover:scale-105 transition-all duration-300"
            >
              <ArrowLeft className="h-8 w-8 text-teal-400 mx-auto mb-4" />
              <span className="text-white font-medium">Contact Support</span>
            </Link>

            <Link
              to="/resources/ai-explainers"
              className="glass-card p-6 rounded-xl backdrop-blur-md hover:scale-105 transition-all duration-300"
            >
              <Search className="h-8 w-8 text-teal-400 mx-auto mb-4" />
              <span className="text-white font-medium">Explore Resources</span>
            </Link>
          </div>

          <div className="glass-card p-8 rounded-xl backdrop-blur-md">
            <h3 className="text-xl font-semibold text-white mb-4">Popular Pages</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Link 
                to="/tools/roi-calculator"
                className="text-teal-400 hover:text-teal-300 transition-colors"
              >
                ROI Calculator
              </Link>
              <Link 
                to="/tools/ai-readiness-assessment"
                className="text-teal-400 hover:text-teal-300 transition-colors"
              >
                AI Readiness Assessment
              </Link>
              <Link 
                to="/resources/ai-explainers"
                className="text-teal-400 hover:text-teal-300 transition-colors"
              >
                AI Technology Explained
              </Link>
              <Link 
                to="/blog"
                className="text-teal-400 hover:text-teal-300 transition-colors"
              >
                Blog & Insights
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}